import React from 'react';
import { FiZap, FiWifi, FiCpu, FiActivity, FiGlobe } from 'react-icons/fi';
import { clsx } from 'clsx';
import SafeIcon from '../common/SafeIcon';

const ConnectionTypeBadge = ({ connectionInfo }) => {
  const { type, effective, is5G } = connectionInfo;

  // Determine styling based on connection type
  const getTheme = () => {
    if (is5G) return {
      bg: 'bg-primary/10',
      border: 'border-primary/30',
      text: 'text-primary',
      icon: FiZap,
      glow: 'shadow-[0_0_15px_rgba(16,185,129,0.2)]',
      label: '5G ULTRA WIDEBAND'
    };
    if (type.includes('Wi-Fi')) return {
      bg: 'bg-blue-500/10',
      border: 'border-blue-500/30',
      text: 'text-blue-400',
      icon: FiWifi,
      glow: 'shadow-[0_0_15px_rgba(59,130,246,0.2)]',
      label: 'WI-FI 6 FIDELITY'
    };
    if (type.includes('Ethernet')) return {
      bg: 'bg-purple-500/10',
      border: 'border-purple-500/30',
      text: 'text-purple-400',
      icon: FiCpu,
      glow: 'shadow-[0_0_15px_rgba(168,85,247,0.2)]',
      label: 'GIGABIT ETHERNET'
    };
    return {
      bg: 'bg-warning/10',
      border: 'border-warning/30',
      text: 'text-warning',
      icon: FiGlobe,
      glow: 'shadow-[0_0_15px_rgba(245,158,11,0.2)]',
      label: 'STANDARD GATEWAY'
    };
  };

  const theme = getTheme();

  return (
    <div className={clsx(
      "flex items-center gap-3 p-1.5 pr-4 rounded-2xl border backdrop-blur-md transition-all duration-500",
      theme.bg, theme.border, theme.glow
    )}>
      <div className={clsx(
        "w-10 h-10 rounded-xl flex items-center justify-center border shrink-0 shadow-inner",
        theme.border, theme.bg
      )}>
        <SafeIcon icon={theme.icon} size={18} className={clsx(theme.text, is5G && "animate-pulse")} />
      </div>
      <div className="min-w-0">
        <div className={clsx("text-[8px] font-black uppercase tracking-[0.2em] leading-none mb-1 opacity-80", theme.text)}>
          {theme.label}
        </div>
        <div className="flex items-center gap-2">
          <span className="text-xs font-bold text-white truncate">
            {effective || 'Detecting...'}
          </span>
          <div className="flex gap-0.5 items-end h-3">
            {[1, 2, 3, 4].map((bar) => (
              <div 
                key={bar} 
                className={clsx(
                  "w-1 rounded-full transition-all duration-700",
                  bar <= 3 ? theme.bg.replace('/10', '') : 'bg-white/10',
                  bar === 1 ? 'h-1.5' : bar === 2 ? 'h-2' : bar === 3 ? 'h-2.5' : 'h-3'
                )} 
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConnectionTypeBadge;